export default "__VITE_ASSET__COxvVjEm__"